import React, { useMemo } from "react";

import { Spin } from "antd";

import { PreferencesConfig } from "./preferences.model";
import { usePreferences } from "./hooks/preferences";
import { Button } from "@companion-core/shared/app/Components/Button";
import { redirectTo } from "@companion-core/web/src/Utilities/navigation";
import { useMediaQuery } from "@companion-core/web/src/Utilities/mediaQuery";
import { PreferencesSwitch } from "@companion-core/shared/app/Components/MyAccount/Sections/Preferences/PreferencesSwitch";
import { MyAccountSubModule } from "@companion-core/shared/app/Interfaces/myAccount";

import "@companion-core/web/src/Assets/Styles/scss/preferences.scss";

export const Preferences = () => {
  const { t, data, isMemberFetching, myAccountModule } = usePreferences();
  const isMobileSize = useMediaQuery("(max-width: 768px)");
  const preferencesConfig = myAccountModule?.modules.preferences;

  const enabledModulesCount = useMemo(
    () =>
      Object.entries(myAccountModule?.modules)?.filter(
        (module) => !!(module[1] as MyAccountSubModule)?.enabled,
      ).length,
    [myAccountModule],
  );
  const showTitle = useMemo(
    () => isMobileSize || enabledModulesCount <= 1,
    [isMobileSize, enabledModulesCount],
  );

  return isMemberFetching ? (
    <Spin className="preferences__spin" size="large" />
  ) : (
    <div className="preferences my-account__section">
      {showTitle && (
        <div
          data-testid="preferences__title"
          className="my-account__section-title super-title-3 preferences__title">
          {t("my-account.preferences.titlev2")}
        </div>
      )}
      <div className="preferences__content">
        {preferencesConfig?.forms.map((entry: PreferencesConfig) => (
          <div
            className="preferences__section"
            key={entry.name}
            data-testid={`preferences__section-${entry.name}`}>
            {entry.type === "cta" && (
              <>
                <span
                  className="body-text-3"
                  data-testid={`preferences__section-cta-title-${entry.name}`}>
                  {t(`my-account.preferences.${entry.name}.title`)}
                </span>
                <>
                  <span
                    className="preferences__section-cta-description body-text-6"
                    data-testid={`preferences__section-cta-description-${entry.name}`}>
                    {t(`my-account.preferences.${entry.name}.description`)}
                  </span>
                  <Button
                    testID={`preferences__section-cta-button-${entry.name}`}
                    label={t("my-account.preferences.modify")}
                    onClick={() =>
                      redirectTo(
                        entry.link?.replace("[PUID]", data?.id ?? "") ?? "",
                        "external",
                        undefined,
                        "_blank",
                      )
                    }
                  />
                </>
              </>
            )}
            {entry.type === "switch" && data && (
              <PreferencesSwitch
                entry={entry}
                checked={data[`marketing_${entry.name}`] === "opt-in" ? true : false}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
